import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "chart-wrapper" };
import { computed } from 'vue';
import { Chart, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler } from 'chart.js';
import { Line } from 'vue-chartjs';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExpenseTrendChart',
    props: {
        labels: {},
        datasets: {}
    },
    setup(__props) {
        Chart.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler);
        const props = __props;
        const chartData = computed(() => ({
            labels: props.labels,
            datasets: props.datasets.map(dataset => ({
                tension: 0.4,
                borderWidth: 3,
                pointRadius: 0,
                pointHoverRadius: 6,
                pointHoverBorderWidth: 3,
                pointHoverBackgroundColor: dataset.borderColor,
                pointHoverBorderColor: '#fff',
                fill: false,
                pointHoverAnimation: true,
                ...dataset
            }))
        }));
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2000,
                easing: 'easeOutQuart',
                delay: (context) => {
                    return context.dataIndex * 50;
                },
                x: {
                    type: 'number',
                    easing: 'easeOutQuart',
                    duration: 2000,
                    from: NaN
                },
                y: {
                    type: 'number',
                    easing: 'easeOutQuart',
                    duration: 2000,
                    from: (ctx) => {
                        return ctx.chart.scales.y.getPixelForValue(0);
                    }
                }
            },
            animations: {
                x: {
                    duration: 2000,
                    easing: 'easeOutQuart'
                },
                y: {
                    duration: 2000,
                    easing: 'easeOutQuart'
                }
            },
            interaction: {
                intersect: false,
                mode: 'index'
            },
            transitions: {
                show: {
                    animations: {
                        x: {
                            from: 0
                        },
                        y: {
                            from: 0
                        }
                    }
                },
                hide: {
                    animations: {
                        x: {
                            to: 0
                        },
                        y: {
                            to: 0
                        }
                    }
                }
            },
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle'
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const value = context.parsed.y;
                            return `${context.dataset.label}: $${value.toFixed(2)} millones`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    grid: {
                        display: false
                    }
                },
                y: {
                    beginAtZero: true,
                    ticks: {
                        callback: (value) => {
                            const numericValue = typeof value === 'string' ? Number(value) : value;
                            return `$${numericValue.toFixed(0)}M`;
                        }
                    },
                    title: {
                        display: true,
                        text: 'Millones de USD'
                    }
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Line), {
                    data: chartData.value,
                    options: chartOptions
                }, null, 8, ["data"])
            ]));
        };
    }
});
